//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import ReCAPTCHA from "react-google-recaptcha";
//import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
//import ReactGA from "react-ga4";
// Images
//import bgImage from "assets/images/strategia.jpg";
import { Card, CardContent, Typography, Button, TextField } from "@mui/material";
//import RotatingCard from "./RotatingCard";
//import RotatingCardFront from "./RotatingCardFront";
//import RotatingCardBack from "./RotatingCardBack";
//import { useTranslation } from "react-i18next";
//import bgFront from "assets/images/rotating-card-bg-front.jpeg";
//import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import { FormControl, Select, MenuItem } from "@mui/material";
import {
  FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY,
  CREATE_STRATEGYCOMMENT,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import Box from "@mui/material/Box";
//import Slider from "@mui/material/Slider";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Strategycomments = ({ selectedKunta, setError, categories }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  const [idea, setIdea] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  const [ideatext, setIdeatext] = useState("");
  const [categ, setCateg] = useState([{ name: "Visio", text: "" }]);
  const [selectedIdea, setSelectedIdea] = useState(categ[0].text);
  const [votes, setVotes] = useState([]);
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  const [scomments, setScomments] = useState([]);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted] = useState(false);
  const [executing] = useState(false);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = "anonym";
    if (localStorage.getItem("id") !== undefined) {
      // eslint-disable-next-line
      id = localStorage.getItem("id");
    }
    //console.log(id);
    /*ReactGA.event({
      category: "Strategycomments",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    });
    */
    // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/

    let cat = [];
    if (categories !== undefined) {
      cat = categories.split("|||");
    }
    //console.log(cat);
    let c = [];
    if (cat.length > 0) {
      for (let i = 0; i < cat.length + 1; i++) {
        if (i % 2 === 0) {
          c.push({ name: cat[i], text: cat[i + 1] });
        }
      }
      setCateg(c);
    } else {
      setCateg(content);
    }
  }, []);
  const [createStrategycomment] = useMutation(CREATE_STRATEGYCOMMENT, {
    refetchQueries: [
      { query: FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const scommentssw = useQuery(FIND_STRATEGYCOMMENTS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });

  useEffect(() => {
    let scommentss = [];
    //console.log(scommentssw);
    //let municipalitiess = [];
    if (scommentssw.data) {
      scommentss = scommentssw.data.findStrategyCommentsByMunicipality;
      //setOrgans(organss);
      //console.log(scommentss);
      //let secs = scommentss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setscomments(secs);
      setScomments(scommentss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [scommentssw]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    createStrategycomment({
      variables: {
        strategytext: idea,
        strategyclass: selectedIdea,
        strategydatetime: pvm.toString(),
        municipality: selectedKunta,
        userid: localStorage.getItem("id"),
      },
    });
    setSelectedIdea("");
    setIdea("");
    window.confirm("Kiitos kommentistasi");
    setVerified(!verified);
  };

  const content = [
    {
      name: t("strategy.vision"),
      text: t("strategy.visiontext"),
    },
    {
      name: t("strategy.vitality"),
      text: t("strategy.vitalitytext"),
    },
    {
      name: t("strategy.wellbeing"),
      text: t("strategy.wellbeingtext"),
    },
    {
      name: t("strategy.nature"),
      text: t("strategy.naturetext"),
    },
    {
      name: t("strategy.involving"),
      text: t("strategy.involvingtext"),
    },
    {
      name: t("strategy.economy"),
      text: t("strategy.economytext"),
    },
    {
      name: t("strategy.evaluation"),
      text: t("strategy.evaluationtext"),
    },
    {
      name: t("strategy.action"),
      text: t("strategy.actiontext"),
    },
  ];

  useEffect(() => {
    let filtered = categ.filter((cont) => {
      return cont.name === selectedIdea;
    });
    //console.log(selectedIdea);
    //console.log(filtered);
    if (filtered.length > 0) {
      setIdeatext(filtered[0].text);
    }
  }, [selectedIdea]);
  const getAiheet = () =>
    categ.map((aihe) => {
      return (
        <MenuItem value={aihe.name} key={aihe.name}>
          {aihe.name}
        </MenuItem>
      );
    });

  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategycommentid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategycommentid === p).length;
  }
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    //console.log(token);
    setVerified(!verified);
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          {t("strategy.selectcategory")}
          <br />
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedIdea}
              onChange={(e) => setSelectedIdea(e.target.value)}
            >
              {getAiheet()}
            </Select>
          </FormControl>
          <br />
          <br />
          <Typography variant="h5" gutterBottom>
            {selectedIdea}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {ideatext}
          </Typography>
          <br />
          <Typography variant="h6" gutterBottom>
            {t("strategy.sharecomment")}
          </Typography>
          <TextField
            label={t("strategy.writeidea")}
            multiline
            fullWidth
            minRows={3}
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <br />
          <br />
          <div style={{ width: "100%", marginLeft: "30%" }}>
            <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
          </div>
          <br />
          <br />
          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={handleSubmit}
            disabled={!verified}
            executing={executing}
            submitted={submitted}
          >
            {t("strategy.savecomment")}
          </Button>
        </CardContent>
      </Card>
      <MKTypography variant="h4" gutterBottom>
        {t("strategy.commentwall")}
      </MKTypography>
      {scomments.length === 0 && <MKTypography>{t("strategy.noideas")}</MKTypography>}
      {scomments.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {item.strategyclass}: {item.strategytext}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Strategycomments;
/**
 * 
 * import React, { useState } from "react";
import { Card, CardContent, Typography, Button, TextField } from "@mui/material";

export default function ParticipationDemo() {
  const [idea, setIdea] = useState("");
  const [ideas, setIdeas] = useState([]);

  const handleSubmit = () => {
    if (idea.trim()) {
      setIdeas([{ text: idea, votes: 0 }, ...ideas]);
      setIdea("");
    }
  };

  const handleVote = (index) => {
    const updatedIdeas = [...ideas];
    updatedIdeas[index].votes++;
    setIdeas(updatedIdeas);
  };

  return (
    <div style={{ padding: "1rem", maxWidth: "600px", margin: "0 auto" }}>
      <Typography variant="h4" gutterBottom>
        Osallistu kuntastrategian valmisteluun
      </Typography>

      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Jaa ideasi
          </Typography>
          <TextField
            label="Kirjoita ideasi tähän"
            multiline
            fullWidth
            minRows={3}
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <Button variant="contained" onClick={handleSubmit}>
            Lähetä idea
          </Button>
        </CardContent>
      </Card>

      <Typography variant="h6" gutterBottom>
        Ideaseinä
      </Typography>
      {ideas.length === 0 && <Typography>Ei vielä ideoita.</Typography>}
      {ideas.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography>{item.text}</Typography>
            <Button variant="outlined" onClick={() => handleVote(index)}>
              👍 {item.votes}
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
 */
/**
 * 
 * <Box sx={{ width: "100%" }}>
                Lapset ja nuoret
                <Slider
                  aria-label="Lapset ja nuoret"
                  defaultValue={limit1}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit1(e.target.value)}
                  onDragStop={(e) => handleLimit1(e.target.value)}
                />
                Seniorit
                <Slider
                  aria-label="Seniorit"
                  defaultValue={limit2}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit2(e.target.value)}
                />
                Liikunta ja vapaa-aika
                <Slider
                  aria-label="Liikunta ja vapaa-aika"
                  defaultValue={limit3}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit3(e.target.value)}
                />
                Kulttuuri
                <Slider
                  aria-label="Kulttuuri"
                  defaultValue={limit4}
                  getAriaValueText={valuetext}
                  valueLabelDisplay="auto"
                  shiftStep={10}
                  step={1}
                  marks
                  min={0}
                  max={100}
                  onChange={(e) => handleLimit4(e.target.value)}
                />
 */
/**
 * 
 *   function handleLimit1(value) {
    if (limit - value > -1) {
      setLimit1(value);
    } else {
      setLimit1(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }

  function handleLimit2(value) {
    if (limit - value > -1) {
      setLimit2(value);
    } else {
      setLimit2(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }
  function handleLimit3(value) {
    if (limit - value > -1) {
      setLimit3(value);
    } else {
      setLimit3(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(0);
    } else {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    }
    setLimit(100 - limit1 - limit2 - limit3 - limit4);
    //console.log(limit);
  }
  function handleLimit4(value) {
    if (limit - value > -1) {
      setLimit4(value);
    } else {
      setLimit4(100 - limit);
    }
    if (100 - limit1 - limit2 - limit3 - limit4 < 0) {
      setLimit(100 - limit1 - limit2 - limit3 - limit4);
    } else {
      setLimit(0);
    }
    //console.log(limit);
  }

 */
